<mat-toolbar id="logos">
    <div class="logos-container">
        <div class="logo_left">
            <img id="logo_left" [src]="appidService.appLogo" />
            <span id="tagline">{{tagline}}</span>
        </div>

        <!-- TO DO: Add conditional to show the ad, it is currently hardcoded for testing purposes. -->
        <div class='content_advertisement'>
            <!-- <img id="img_advertisement" width="350" src="assets\publicity_test.png">
            <p class="advertisement-text">Third-party sponsored banner.</p> -->
        </div>
        
        <div class="logo_right">
            <!-- <img src="assets\BEYOND ALPHA Logo.png" width="180" id="logo_right" /> -->
            <img *ngIf="orgLogo" 
                [src]="orgLogo" 
                id="logo_right"
                (load)="logoLoaded = true"
                (error)="logoLoaded = false" />
            <span id="org-name" *ngIf="!logoLoaded">{{orginfo?.orgName}}</span>
        </div>
    </div>
</mat-toolbar>

<!-- If we don't have information to display in the app and organization dropdown, 
 then we won't show the entire block to avoid having a blank space between the header and the top navs. -->
<mat-toolbar id="dropdowns" *ngIf="appsForThisOrg || orginfo">
    <mat-form-field appearance="outline" id="apps">
        <mat-select (selectionChange)="appChangeClicked($event)" [value]="selectedApp?.toString()" placeholder="Select app">
            <mat-option value="">- Select -</mat-option>

            <mat-option *ngFor="let app of appsForThisOrg" [value]="app.id">
                {{ app.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

	<!-- org dropdown -->
    <mat-form-field appearance="outline">
        <mat-select class="org-dropdown" (selectionChange)="onOrgChange($event)" [value]="selectedOrg">
            <mat-option value="">- Select -</mat-option>

            <!-- ancestor -->
            <mat-option *ngIf="orginfo.ancestor"
                [value]="orginfo.ancestor.ancestor_org_id">{{orginfo.ancestor.org_name}}</mat-option>
            
            <!-- current org -->
            <mat-option [value]="this.auth.getOrg()">
                <span *ngIf="orginfo.ancestor"></span> &nbsp; {{orginfo.orgName}}
            </mat-option>

            <!-- show descendants as options with an indent -->
            <ng-container *ngIf="orginfo.descendants">
                <mat-option *ngFor="let org of orginfo.descendants" [value]="org.org_id">
                    <span *ngIf="orginfo.ancestor"></span>
                    &nbsp;&nbsp;&nbsp;&nbsp;{{org.org_name}}
                </mat-option>
            </ng-container>

            <!-- siblings -->
            <ng-container *ngIf="orginfo.siblings">
                <mat-option *ngFor="let org of orginfo.siblings" [value]="org.org_id">
                    <span *ngIf="orginfo.ancestor"></span> &nbsp; {{org.org_name}}
                </mat-option>
            </ng-container>
        </mat-select>
    </mat-form-field>
</mat-toolbar>